import {
  Badge,
  Group,
  Text,
  ActionIcon,
  Tooltip,
  TagsInput,
} from "@mantine/core";
import { IconEdit, IconX } from "@tabler/icons-react";

export default function EditableTagsInput({
  value,
  fieldName,
  editingField,
  setEditingField,
  onSave,
  data,
  placeholder = "Click to edit",
  hideTitle = false,
  disabled = false,
}) {
  const isEditing = editingField === fieldName;

  if (isEditing) {
    return (
      <Group gap="xs">
        <TagsInput
          data={data}
          value={value}
          onChange={(newValue) => onSave(fieldName, newValue)}
          placeholder={placeholder}
          searchable
          style={{ flex: 1 }}
          autoFocus
        />
        <ActionIcon color="red" onClick={() => setEditingField(null)}>
          <IconX size={16} />
        </ActionIcon>
      </Group>
    );
  }

  return (
    <Group gap="xs">
      {value?.length > 0 ? (
        value.map((item) => (
          <Badge key={item} variant="light" size="sm">
            {item}
          </Badge>
        ))
      ) : (
        <Text
          c="dimmed"
          style={{ cursor: disabled ? "default" : "pointer" }}
          onClick={() => !disabled && setEditingField(fieldName)}
        >
          {placeholder}
        </Text>
      )}
      {!disabled && !hideTitle && (
        <Tooltip label="Click to edit">
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={() => setEditingField(fieldName)}
          >
            <IconEdit size={14} />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  );
}
